import {BaseEntity} from "./base-entity";

export class UserRegistrationStatus extends BaseEntity{
  passwordProvidedDate: string;
  phoneProvidedDate: string;
  caslacceptDate: string;
  constructor(userRegistrationStatus? : UserRegistrationStatus) {
      super(userRegistrationStatus);
  }
}

export type NotificationPreferenceType = 'OPT_IN' | 'OPT_OUT';
export const NotificationPreferenceValue = {
    optIn : <NotificationPreferenceType>'OPT_IN',
    optOut: <NotificationPreferenceType>'OPT_OUT'
}

export class User   extends BaseEntity{
    createdTimeStamp : string;
    emailId : string;
    firstName : string;
    lastName : string;
    lastUpdatedTimeStamp : string;
    password : string;
    retypePassword : string;
    oldPassword : string;
    passwordSalt : string;
    loginId : string;
    retypeLoginId: string;
    username : string;
    userStatus : string;
    accessProfileId : number;
    documentProfileId : number;
    publicAccountId : string;
    tokenType : string;
    id : number;
    rememberMe: boolean;
    registrationToken? : string;
    userAccountProfileId: number;
    termsAcceptedDate: Date;
    userRegistrationStatus: UserRegistrationStatus;
    passwordChangeRequired: boolean;
    customerAccountId: number;
    customerAccountName: string;
    hasAnyRealEstateAgentNotification: boolean;
    notificationPreference: NotificationPreferenceType;



      constructor(user? : User) {
        super(user);
        if(user) {
          if(user.userRegistrationStatus) {
            this.userRegistrationStatus = new UserRegistrationStatus(user.userRegistrationStatus);
          }
        }
      }

      get fullName() : string {
        return `${this.firstName} ${this.lastName}`;
      }

      isNotificationOptedIn() : boolean {
          return this.notificationPreference != NotificationPreferenceValue.optOut;
      }

      isNotificationOptedOut() : boolean {
          return this.notificationPreference == NotificationPreferenceValue.optOut;
      }

      get initials() : string {
          return `${this.firstName? this.firstName.charAt(0) : ''} ${this.lastName? this.lastName.charAt(0) : ''}`;
      }

}
